import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust the path based on your project structure

const UpdatePlay = () => {
  const [playData, setPlayData] = useState({
      selectedCategory: '',
      selectedGamename:'',
      selectedCardGroup: '',
      scenario: '',
      userInput: '',
      timeElapsed: '',
      score: '',
  });

  const navigate = useNavigate();
  const { playid } = useParams();

  useEffect(() => {
    fetchPlayData();
  }, []);

  const fetchPlayData = () => {
    axios({
      url: API.GET_PLAY_BYID(playid),
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setPlayData(res.data[0]); // Assuming the API returns an array with the object at index 0
      })
      .catch((err) => {
        alert('Error fetching play data: ' + err);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPlayData({ ...playData, [name]: value });
  };

  const updatePlay = (e) => {
    e.preventDefault();
    axios
      .put(API.PUT_PLAY_API(playid), playData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        alert('Play updated successfully');
        navigate('/playdbtable');
      })
      .catch((err) => {
        console.error('Error updating play:', err);
        alert('Error updating play: ' + err.message);
      });
  };

  const goBack = () => {
    navigate('/playdbtable');
  };

  return (
    <div className='bg-[#B5B5B5] h-auto pb-20 pt-10'>
      <div className='max-w-4xl mx-auto pt-10'>
        <form onSubmit={updatePlay} className='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4'>
          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Category</label>
            <input
              type='text'
              name='selectedCategory'
              value={playData.selectedCategory}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Name</label>
            <input
              type='text'
              name='selectedGamename'
              value={playData.selectedGamename}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Card Group</label>
            <input
              type='text'
              name='selectedCardGroup'
              value={playData.selectedCardGroups}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Scenario</label>
            <textarea
              name='scenario'
              value={playData.scenario}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>User Input</label>
            <textarea
              name='userInput'
              value={playData.userInput}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Time Elapsed</label>
          <input
            type="text"
            name="timeElapsed"
            value={playData.timeElapsed || ''}
            readOnly
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-100 cursor-not-allowed"
          />
        </div>


          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Score</label>
            <textarea
              name='score'
              value={playData.score}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='flex items-center justify-between'>
            <button
              type='submit'
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Update
            </button>
            <button
              type='button'
              onClick={goBack}
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdatePlay;
